var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('div',{on:{"click":function($event){_vm.show = (_vm.show==true?false:true)}}},[_vm._v(_vm._s(this.$getDictName(_vm.cateVal,_vm.vval)))]),(_vm.show)?_c('div',[_vm._v(_vm._s(this.$getDictdes(_vm.cateVal,_vm.vval)))]):_vm._e(),(_vm.show)?_c('div',[_c('dictname',{attrs:{"category":"haiwaishuoming_cesuan","v":_vm.vval}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }